<script lang="ts">
  import {getContext} from 'svelte';
  import {IMAGES_NEWS} from '@/const/images';
  import {PATHS} from '@/const/paths';
  import {LINKS} from '@/const/link';
  import {env} from '@/helper/env';
  import {fixLink$} from '@/store/lang';
  import Menu from '@/widgets/trigger/Menu.svelte';
  import homeLang from '@/modules/homepage/HomePage.lang.js';
  import MenuItemView from '../popups/components/MenuItemView.svelte';
  import lang from '../Header.lang';

  export let web3 = false;
  export let isTop = false;
  export let mode = 'default';

  const LG = getContext('LG');
  const configs = {
    default: {
      logo: IMAGES_NEWS.LOGO_PULSE_LIGHT,
      bannerBg: '#fff',
      bannerColor: '#000',
      activeColor: '#45e555',
    },
    dark: {
      logo: IMAGES_NEWS.LOGO_PULSE_DARK,
      bannerBg: 'transparent',
      bannerColor: '#fff',
      activeColor: '#45e555',
    },
  };
  const navs = [
    {
      title: LG(lang.Home),
      url: $fixLink$(PATHS.HOME.pathname),
    },
    {
      title: LG(lang.Chat2Earn),
      url: $fixLink$(PATHS.WEB3_SOCIAL_TRADE_PT_REWARDS.pathname),
    },
    {
      title: LG(homeLang.Trade),
      children: [
        {
          title: LG(lang.BuyCrypto),
          url: $fixLink$(PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname),
        },
        {
          title: LG(lang.Spot),
          url: LINKS.PHEMEX_SPOT_TRADE + '/PTUSDT',
        },
        {
          title: LG(lang.Contract),
          url: LINKS.PHEMEX_CONTRACT_TRADE_USDS,
        },
      ],
    },
    {
      title: LG(lang.PhemexToken),
      children: [
        {
          title: LG(lang.PhemexTokenBenefits),
          url: $fixLink$(PATHS.WEB3_EQUITY_BENEFITS.pathname),
        },
        {
          title: LG(lang.Web3Whitepaper),
          url: LINKS.Web3Whitepaper,
        },
      ],
    },
  ];
  const launchApp = {
    title: LG(lang.LaunchPulseApp),
    url: $fixLink$(PATHS.WEB3_SOCIAL_TRADE_EXPLORE_GROUPS.pathname),
  };

  function isCurrent(nav) {
    if (env.isBrowser) {
      const {url, children} = nav;
      if (window.location.pathname === url) {
        return true;
      }
      if (children) {
        for (let i = 0; i < children.length; i++) {
          if (isCurrent(children[i])) {
            return true;
          }
        }
      }
    }
    return false;
  }
</script>

<style>
  .navs {
    position: relative;
    z-index: 100;
    gap: 44px;
  }
  .header-place {
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    padding: 0 40px;
    width: 100%;
    height: 64px;
    min-height: 64px;
    background-color: transparent;
  }
  .header-place.web3 {
    border-bottom-color: transparent;
    padding: 0;
    height: 64px;
    min-height: 64px;
  }
  .logo {
    position: absolute;
    top: 0;
    left: 0;
  }
  .header-menu {
    line-height: 40px;
    font-weight: bold;
    color: var(--bannerColor);
  }
  .header-menu.current {
    color: var(--activeColor);
  }
  .logo {
    position: relative;
    width: 200px;
    height: 40px;
  }
  .logo img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
  .menu-items {
    padding: 12px 8px;
    background: #fff;
    cursor: default;
    box-shadow: 0 0 20px 0 rgba(204, 204, 204, 0.4);
  }
  @media screen and (max-width: 640px) {
    .header-place {
      display: none;
      height: unset;
      min-height: unset;
    }
  }
</style>

<div class="header-place df aic" class:web3 style="--bannerBg:{configs[mode].bannerBg};--bannerColor:{configs[mode].bannerColor};--activeColor:{configs[mode].activeColor}">
  <a class="df mt2 logo" href={$fixLink$(PATHS.HOME.pathname)} target="_self">
    <img alt="Logo" src={configs[mode].logo} />
  </a>
  <div class="navs f1 df jcc aic">
    {#each navs as nav}
      {#if nav.children}
        <Menu hoverColor={isCurrent(nav) ? configs[mode].activeColor : configs[mode].bannerColor} color={isCurrent(nav) ? configs[mode].activeColor : configs[mode].bannerColor}>
          <span slot="trigger" class="header-menu" class:current={isCurrent(nav)}>{nav.title}</span>
          <div class="menu-items">
            {#each nav.children as child}
              <MenuItemView link={child.url} target="_self" title={child.title} />
            {/each}
          </div>
        </Menu>
      {:else}
        <a class="header-menu" href={nav.url} class:current={isCurrent(nav)}>{nav.title}</a>
      {/if}
    {/each}
    <a class="header-menu" class:current={isCurrent(launchApp)} href={launchApp.url}>
      {launchApp.title}
    </a>
  </div>
  <slot />
</div>
